<template>
    <div>
        <div id="output" style="border:1px solid #ccc;background-color: rgb(238, 234, 234);overflow: auto;"></div>
        <div class="w3-flex bottom-btn">
            <input type="text" class="w3-input" v-model="inputTxt" placeholder="待发信息" required
                @keydown.enter="onEnter">
            <button type="button" :disabled="btnDisabled" class="w3-button w3-blue" @click="onEnter">发送</button>
        </div>
    </div>
</template>

<script>

var websocket;
var connTimes = 0;
var connected = false;

export default {
    data() {
        return {
            wlcMsg: '',
            to: '',
            inputTxt: '',
            nickName: '',
            userName: '',
            userPass: '',
            btnDisabled: false
        };
    },
    created() {
        const query = this.$route.query;

        if (query.u && query.p) {
            sessionStorage.setItem('userName', query.u);
            sessionStorage.setItem('userPass', query.p);
        }
        this.userName = sessionStorage.getItem('userName');
        this.userPass = sessionStorage.getItem('userPass');
        if (this.userName && this.userPass) {
            this.login();
            setInterval(() => {
                this.KeepAlive();
            }, 10000);
        } else {
            this.$router.push('/login');
        }
    },
    methods: {
        KeepAlive() {
            if (connected) {
                const msg = `{"id":"keepAlive"}`;
                this.sendMsg(msg);
            }
        },
        onEnter() {
            this.doSend();
        },
        async login() {
            this.startWebSocket(this.$wssAddr);
        },
        formatDate(value, format = 'YYYY/MM/DD HH:mm:ss') {

            if (!value) return ''

            const date = new Date(value)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            let df;
            const now = new Date();

            if (now.getDate() === date.getDate()) {
                df = format.replace('YYYY/MM/DD', '今天');
            } else if (now.getDate() - 1 === date.getDate()) {
                df = format.replace('YYYY/MM/DD', '昨天');
            } else if (now.getDate() < date.getDate() + 7) {
                const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                const weekDay = weekDays[date.getDay()];
                df = format.replace('YYYY/MM/DD', weekDay);
            } else {
                df = format;
            }
            return df
                .replace('YYYY', year)
                .replace('MM', month)
                .replace('DD', day)
                .replace('HH', hours)
                .replace('mm', minutes)
                .replace('ss', seconds);

        },
        startWebSocket(wsUri) {
            try {
                websocket = new WebSocket(wsUri);
                websocket.onopen = this.onOpen;
                websocket.onclose = this.onClose;
                websocket.onmessage = this.onMessage;
                websocket.onerror = this.onError;
            } catch (error) {
                this.appendToChatWin(error);
            }

        }, onOpen() {
            connected = true;
            connTimes = 0;
            const msg = `{"id":"login","body":{"appId":"${this.userName}","token":"${this.userPass}","to":""}}`;
            this.sendMsg(msg);

        }, onClose() {
            connected = false;
            this.appendToChatWin("<span style='color:red'>连接已断开!</span>");
            if (connTimes < 3) {
                websocket.close();
                this.appendToChatWin("<span style='color:red'>正在重连!</span>");
                connTimes++;
                this.startWebSocket(this.$wssAddr);
            } else {
                this.appendToChatWin("<span style='color:red'>重连多次失败，请稍后再试!</span>");
            }
        }, onMessage(evt) {
            connected = true;
            const msgObj = JSON.parse(evt.data);

            if (msgObj != null) {
                const id = msgObj.id;
                const body = msgObj.body;

                if (id == "loginS") {

                    this.nickName = body.nickName;
                    this.to = body.to;
                    this.wlcMsg = body.msg;
                    this.KeepAlive();

                } else if (id == "chatRecords") {
                    this.clearMsg();
                    const list = body;

                    for (let i in list) {
                        const tm = list[i].tm;
                        const f = list[i].f;
                        const c = list[i].c;

                        let isR = false;
                        if (f == this.nickName) {
                            isR = true;
                        }
                        this.onMsg(f, tm, c, isR);
                    }
                    this.appendToChatWin("<span style='color:green'>" + this.wlcMsg + "</span>", "newreply");

                } else if (id == "msg") {
                    let tm = body.tm;
                    let f = body.f;
                    let c = body.c;

                    var isR = false;
                    if (f == this.nickName) {
                        isR = true;
                    }
                    this.onMsg(f, tm, c, isR);
                } else if (id == "kick") {
                    let tm = body.tm;
                    let f = body.f;
                    let c = body.c;
                    this.onMsg(f, tm, c, false);

                    connected = false;
                    this.btnDisabled = true;
                }

            }
        }, clearMsg() {
            document.getElementById("output").innerHTML = "";
        }, onMsg(from, time, content, isR) {

            if (isR) {
                this.appendToChatWin(from + '&nbsp;' + this.formatDate(time), "newmsg");
                this.appendToChatWin(content, "newmsg bubbler");
            } else {
                this.appendToChatWin(from + '&nbsp;' + this.formatDate(time), "newreply");
                this.appendToChatWin(content, "newreply bubblel");
            }

        }, onError() {
            connected = false;
            this.appendToChatWin('<span style="color: red;">发生错误</span> ');
        }, sendMsg(msg) {

            if (typeof websocket === "undefined") {
                alert("还没有连接，或者连接失败，请检测");
                return false;
            }
            if (websocket.readyState == 3) {
                alert("连接已经关闭，请刷新页面");
                return false;
            }
            websocket.send(msg);

        }, doSend() {
            var text = this.inputTxt;
            if (text.trim() == '') {
                alert("请先填写发送信息");
                return false;
            }
            if (text.length > 500) {
                alert("请缩短发送内容再试");
                return false;
            }
            this.inputTxt = '';

            const msg = `{"id":"msg","body":{"to":"${this.to}","msg":"${text}"}}`;

            this.sendMsg(msg);
        },
        appendToChatWin(message, className = "newreply") {

            var div = "<div class='" + className + "'>" + message + "</div>";
            var d = document.getElementById("output");
            if (d == null) {
                console.log("output div is null");
                return;
            }
            d.innerHTML += div;
            d.scrollTop = d.scrollHeight;
        }
    }
};

</script>


<style>
.w3-input:focus {
    outline: none;
    box-shadow: none;
}    
#output {
    height: calc(100vh - 41px);
    position: relative;
    min-height: calc(100vh - 41px);
    /* 确保容器撑满视口高度 */
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align: center;
    color: #2c3e50;

    @media (max-width: 767px) {
        font-size: small;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        font-size: medium;
    }

    @media (min-width: 1025px) {
        font-size: medium;
    }
}

/* 激活的导航链接样式 */
.router-link-active {
    background-color: #003366 !important;
}

/* 固定底部导航 */
.bottom-btn {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 1000;
    /* 确保导航在最顶层 */
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    /* 顶部阴影效果 */
}

.newmsg {
    width: 100%;
    color: blue;
    text-align: right;
}

.bubbler {
    background-color: #90ee90;
    color: black;
    width: fit-content;
    max-width: 60%;
    word-wrap: break-word;
    text-align: left;
    margin-left: auto;
    margin-right: 15px;
    padding: 10px;
    border-radius: 9px;
    overflow: visible;
}

.newreply {
    width: 100%;
    color: green;
    text-align: left;
}

.bubblel {
    background-color: white;
    color: black;
    width: fit-content;
    max-width: 60%;
    word-wrap: break-word;
    padding: 10px;
    margin-left: 15px;
    margin-right: auto;
    border-radius: 9px;
    overflow: visible;
}


</style>
